import { Grid, Slide } from '@mui/material';
import { CrossIcon, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import moment from 'moment';
import { useCallback, useState } from 'react';
import Picker, { PickerValue } from 'react-mobile-picker';
import { StyledFooterButton } from '../../../../components/StyledFooterButton';
import { intl } from '../../../../helpers/IntGlobalProvider';

import { Text } from '../../../../react-components/Text';

interface DatePickerProps {
  value?: Date;
  isOpen: boolean;
  onSelect: (date: Date) => void;
  onCancel: () => void;
  zIndex?: number;
}
function getDayArray(year: number, month: number) {
  const dayCount = new Date(year, month, 0).getDate();
  return Array.from({ length: dayCount }, (_, i) => String(i + 1).padStart(2, `0`));
}

// IT USES Picker from 'react-mobile-picker'
// Picker is a component that is used to select a value from a list of options.
// https://github.com/adcentury/react-mobile-picker#readme

// TODO WE can use transform : rotateX() to give a 3D effect to the picker

export const RoutalDatePicker = ({ onCancel, isOpen, value, onSelect, zIndex }: DatePickerProps) => {
  const [pickerValue, setPickerValue] = useState<PickerValue>({
    year: moment(value).year().toString(),
    month: (moment(value).month() + 1).toString().padStart(2, `0`),
    day: moment(value).date().toString().padStart(2, `0`),
  });

  const handlePickerChange = useCallback((newValue: PickerValue, key: string) => {
    if (key === `day`) {
      setPickerValue(newValue);
      return;
    }

    const { year, month } = newValue;
    const newDayArray = getDayArray(Number(year), Number(month));
    const newDay = newDayArray.includes(newValue.day as string) ? newValue.day : newDayArray[newDayArray.length - 1];
    setPickerValue({ ...newValue, day: newDay });
  }, []);

  const handleOnClose = () => {
    const date = moment(`${pickerValue.year}-${pickerValue.month}-${pickerValue.day}`, `YYYY-MM-DD`).toDate();
    onSelect(date);
  };

  if (!isOpen) return null;

  return (
    <Grid
      style={{
        height: `100%`,
        width: `100%`,
        backgroundColor: RoutalPalette.backgroundPrimary,
        position: `absolute`,
        inset: 0,
        zIndex: zIndex ?? 1003,
        display: `flex`,
        flexWrap: `wrap`,
        justifyContent: `center`,
        alignItems: `center`,
      }}
      className="animate__animated animate__fadeIn animate__faster"
    >
      <Slide
        key={`sliding-datepicker-menu`}
        in={isOpen}
        direction={`up`}
        mountOnEnter
        unmountOnExit
        timeout={{ enter: 400, exit: 300 }}
        style={{
          zIndex: zIndex ?? 1003,
          position: `absolute`,
          backgroundColor: RoutalPalette.white,
          width: `100%`,
          bottom: 0,
          padding: `10px 20px`,
          borderRadius: `10px 10px 0 0`,
        }}
      >
        <Grid>
          <Grid
            style={{
              display: `flex`,
              flexDirection: `row`,
              flexWrap: `nowrap`,
              width: `100%`,

              padding: `8px 20px`,
              justifyContent: `space-between`,
              alignItems: `center`,
            }}
          >
            <Text variant="h6" isBold intlId="drivers.route.date_picker.title" />
            <CrossIcon
              onClick={onCancel}
              style={{ color: `${RoutalPalette.secondary60}`, width: `24px`, height: `24px` }}
            />
          </Grid>
          <Picker value={pickerValue} onChange={handlePickerChange} wheelMode="natural" height={180}>
            <Picker.Column name="year">
              {Array.from({ length: 20 }, (_, i) => `${moment().year() - 10 + i}`).map((year) => (
                <Picker.Item key={year} value={year}>
                  {({ selected }) => (
                    <Text style={{ fontSize: `16px`, fontWeight: selected ? 700 : undefined }}>{year}</Text>
                  )}
                </Picker.Item>
              ))}
            </Picker.Column>
            <Picker.Column name="month">
              {Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, `0`)).map((month) => (
                <Picker.Item key={month} value={month}>
                  {({ selected }) => (
                    <Text style={{ fontSize: `16px`, fontWeight: selected ? 700 : undefined }}>{month}</Text>
                  )}
                </Picker.Item>
              ))}
            </Picker.Column>
            <Picker.Column name="day">
              {getDayArray(Number(pickerValue.year), Number(pickerValue.month)).map((day) => (
                <Picker.Item key={day} value={day}>
                  {({ selected }) => (
                    <Text style={{ fontSize: `16px`, fontWeight: selected ? 700 : undefined }}>{day}</Text>
                  )}
                </Picker.Item>
              ))}
            </Picker.Column>
          </Picker>
          <VSpacer medium />
          <StyledFooterButton
            onClick={() => {
              handleOnClose();
            }}
            style={{ width: `auto` }}
          >
            {intl.formatMessage({ id: `accept` })}
          </StyledFooterButton>
        </Grid>
      </Slide>
    </Grid>
  );
};
